import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AddcapconsegnaPage} from '../../pages/addcapconsegna/addcapconsegna';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditcapconsegnaPage } from '../../pages/editcapconsegna/editcapconsegna';

/**
 * Generated class for the CapconsegnaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-capconsegna',
  templateUrl: 'capconsegna.html',
})
export class CapconsegnaPage {
  caps:any;
  errorMessage: string;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,

  ) {
  }
  ionViewWillEnter () {
    console.log('ionViewWillEnter CapconsegnaPage');
    this.getCaps();

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad CapconsegnaPage');
  }
  openAddCapPage(){
    this.navCtrl.push(AddcapconsegnaPage);

  }
  getCaps() {
    this.rest.getCaps().subscribe(
      caps => this.caps = caps,
      error => this.errorMessage = <any>error);
  }
  openEditCapPage(data){
    this.navCtrl.push(EditcapconsegnaPage, { cap: data });

  }
}



// WEBPACK FOOTER //
// ./src/pages/capconsegna/capconsegna.ts